import { inject } from '@angular/core';
import { Router } from '@angular/router';

export function isIframeGuard() {
  const router = inject(Router);

  if (window.opener) {
    return true;
  }

  router.navigate(['/pay', 'static-finish', 'fail']);

  return false;
}
